module.exports = __webpack_public_path__ + "static/media/UsersNewLogo.fca463d2.svg";